/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClaimImageDTO } from './ClaimImageDTO';
export type ClaimShippingDTO = {
    type?: ClaimShippingDTO.type;
    shippingName?: string;
    shippingNo?: string;
    images?: Array<ClaimImageDTO>;
};
export namespace ClaimShippingDTO {
    export enum type {
        TRANSPORT = 'TRANSPORT',
        OTHER = 'OTHER',
    }
}

